define('glu/grid/filter/fieldFuzzySearch',['require','./fieldSearch'],function(require) {
    'use strict';

    var FieldSearch = require('./fieldSearch');

    return FieldSearch.extend({

        filter: function(field, value, model) {
            try {
                var regex = new RegExp('.*(' + value + ').*', 'i');
            } catch (e) {
                return false;
            }
            field = this.field || field; //property overrides
            var val = model.get(field);
            if (val && val.search) {
                return model.get(field).search(regex) > -1;
            } else if (typeof model.get(field) === 'number') {
                return model.get(field) === +value;
            } else {
                return model.get(field) === value;
            }
        }
    });
});

